<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered"
        >{{ General.WARNING }}!</span
      >
      <div class="close-button custom-pointer" @click="close()">
        <b-icon icon="close" />
      </div>
    </header>
    <div class="modal-content-container">
      <section class="spacing-p-10 spacing-px-50">
        <h2
          class="has-text-color-7 has-text-weight-semibold is-size-6 has-text-centered mb-15"
        >
          {{ General.TEXTS.CONFIRM_CANCEL_REQUEST }}?
        </h2>
        <section>
          <table
            class="table has-text-black custom-overflow"
            :title="General.TEXTS.SIGNATURE_LIST"
            :aria-describedby="General.TEXTS.SIGNATURE_LIST"
          >
            <thead>
              <tr>
                <th class="has-text-color-8 is-size-7">{{ General.NUP }}</th>
                <th class="has-text-color-8 is-size-7">
                  {{ General.NAME.toUpperCase() }}
                </th>
                <th class="has-text-color-8 is-size-7">
                  {{ General.TYPE.toUpperCase() }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, id) in listSignature" :key="id">
                <td class="has-text-color-8 is-size-7">
                  {{ applyMaskNUP(row.process_file.process.nup) }}
                </td>
                <td class="has-text-color-8 is-size-7">
                  {{ row.process_file.attachment_name }}
                </td>
                <td class="has-text-color-8 is-size-7">
                  {{ row.process_file.document_type.type }}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </section>

      <footer class="modal-card-foot is-justify-content-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-warning'"
            size="is-medium"
            @click="cancelRequest"
          >
            {{ General.YES.toUpperCase() }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            size="is-medium"
            outlined
            @click="close"
          >
            {{ General.NO.toUpperCase() }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { General, App } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalCancelSignature",
  props: {
    listSignature: {
      type: Array,
      required: true
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },
  data() {
    return {
      General,
      App,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },
  methods: {
    ...mapActions({
      cancelSignatureFile: "cancelSignatureFileRequest"
    }),

    async cancelRequest() {
      this.isLoading = true;
      const list_signature_cancel = this.listSignature.map(signature => ({
        signature_file_id: signature.id
      }));

      await this.cancelSignatureFile(list_signature_cancel);

      this.close();
      this.isLoading = false;
    },

    close() {
      this.onClose();
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.close-button {
  z-index: 2;
}

.up-25 {
  top: -25px;
  position: relative;
}

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 75vh;
  background-color: $color-1;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

.spacing-mt-5.columns {
  margin-left: 0px;
  margin-right: 10px;
}

.spacing-mb-20 {
  margin-bottom: 10px !important;
}

.custom-overflow {
  height: 110px;
  width: 100%;
  overflow-y: auto;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

table tbody tr:hover {
  background-color: transparent !important;
}
</style>
